module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-dedication element-without-heading",
    attrs: {
      "id": "vol-1-dedication"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "vol-1-dedication-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_vm._v("TO")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_vm._v("WILLIAM HOGGATT, R. I.,")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_vm._v("AND HIS WIFE")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_vm._v("DAZINE")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_vm._v("IN GRATITUDE FOR THEIR FRIENDSHIP")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_vm._v("AND GENIUS")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1833a823","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vol-001-dedication.vue
// module id = 75
// module chunks = 0